var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenWp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 18.0451L1.29441 13.2193C0.563767 11.8978 0.175875 10.4185 0.175875 8.91206C0.175875 4.00051 4.17187 0 9.08794 0C14.004 0 18 3.996 18 8.91206C18 13.8281 14.004 17.8241 9.08794 17.8241C7.61312 17.8241 6.15636 17.4498 4.85293 16.7462L0 18.0451ZM5.09195 14.9376L5.39864 15.118C6.52167 15.7855 7.79803 16.1418 9.08794 16.1418C13.0749 16.1418 16.3132 12.899 16.3132 8.91658C16.3132 4.9296 13.0704 1.69131 9.08794 1.69131C5.10096 1.69131 1.86269 4.93411 1.86269 8.91658C1.86269 10.2335 2.228 11.528 2.91805 12.6645L3.10747 12.9712L2.38586 15.6637L5.09195 14.9376Z",
    fill: "#0AA349"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4031 10.1569C12.0378 9.93587 11.5597 9.69231 11.1267 9.86821C10.7975 10.0035 10.5855 10.5222 10.369 10.7883C10.2608 10.9236 10.1255 10.9461 9.95859 10.8785C8.71378 10.3824 7.76216 9.5525 7.07211 8.40692C6.95484 8.23103 6.97738 8.0867 7.1172 7.92433C7.32466 7.68079 7.58627 7.40115 7.64039 7.07191C7.69451 6.74267 7.54116 6.35931 7.40585 6.06615C7.22996 5.69181 7.03601 5.15962 6.66167 4.94765C6.31438 4.75371 5.86339 4.86195 5.5567 5.11C5.0245 5.54298 4.77192 6.21951 4.77643 6.89152C4.77643 7.08095 4.8035 7.27037 4.8486 7.45529C4.95685 7.89728 5.15978 8.3122 5.3898 8.70458C5.56119 9.00225 5.75061 9.28641 5.95357 9.56604C6.62107 10.4681 7.44643 11.2573 8.40709 11.8437C8.88517 12.1368 9.40384 12.3939 9.93604 12.5698C10.5359 12.7682 11.0681 12.9757 11.7176 12.8494C12.3941 12.7186 13.0616 12.3037 13.3322 11.6497C13.4134 11.4558 13.4495 11.2393 13.4089 11.0363C13.3141 10.6079 12.7459 10.3598 12.4031 10.1569Z",
    fill: "#0AA349"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenWp);
export default __webpack_public_path__ + "static/media/greenWp.1d259c976e9d44c74f2adb3a3883d44f.svg";
export { ForwardRef as ReactComponent };